<template>
  <div>
    <translate v-if="nearbyResults" tag="p" class="help-text">
      All distances are calculated 'as the crow flies'.
    </translate>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class NearbyBookableFooter extends Vue {
  @Prop({ required: true })
  hierarchyText: string

  @Prop({ required: true })
  hierarchyPath: string

  @Prop({ required: false })
  nearbyResults: boolean
}

export default toNative(NearbyBookableFooter)
</script>

<style scoped>
.help-text {
  color: var(--colour-dark-blue);
  text-align: center;
  font-size: var(--small);
}
</style>
